import {
	getModule,
	Module,
	VuexModule,
	Mutation,
	Action,
} from 'vuex-module-decorators';
import store from '@/store';
import schemaz from '../schemaz';
import { SchemaData, SchemaDic, softwareTypes } from '../models.def';
@Module({
	namespaced: true,
	name: 'schemax',
	store,
	dynamic: true,
})
class SchemasModule extends VuexModule {

	public allSchemas: SchemaData[] = [];

	public get groupedSchemas(): SchemaDic {
		const dic: SchemaDic = softwareTypes.reduce(
			(obj, key) => {
				obj[key] = this.allSchemas.filter(
					(data) => data.softwareType === key,
				);
				return obj;
			}, {} as any);
		return dic;
	}

	@Mutation
	public m_updateAllSchemas(schemaDatas: SchemaData[]) {
		this.allSchemas = schemaDatas;
	}

	@Action
	public updateAllSchemas(schemas: SchemaData[]) {
		this.m_updateAllSchemas(schemas);
	}

	@Action
	public addSchema(schema: SchemaData) {
		return schemaz.addSchema(schema);
	}
	@Action
	public updateSchema(schema: SchemaData) {
		return schemaz.updateSchema(schema);
	}

}


export default getModule(SchemasModule);
